import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SitesProvider } from "./context/SitesContext";
import Home from "./pages/Home";
import Partenaire from "./pages/Partenaire"; 
import Informations from "./pages/Informations";
import ParcoursClient from "./pages/ParcoursClient"
import ScrollToTop from "./components/ScrollToTop";
import PaymentProcessingPage from "./components/parcours-client/PaymentProcessingPage";
import PaymentResultSuccess from "./components/parcours-client/PaymentResultSuccess";
import ConditionsGenerales from "./pages/legal/ConditionsGenerales";
import MentionsLegales from "./pages/legal/MentionsLegales";
import PolitiqueConfidentialite from "./pages/legal/PolitiqueConfidentialite";
import PolitiqueCookies from "./pages/legal/PolitiqueCookies";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";

function App() {
  return (
    <SitesProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />}/>
          <Route path="/register" element={<Register />}/>
          <Route path="/garanties" element={<Home />} />
          <Route path="/partenaires" element={<Partenaire />} /> 
          <Route path="/qui-sommes-nous" element={<Informations/>}/>
          <Route path="/parcours-client" element={<ParcoursClient />} />
          <Route path="/paiement/en-cours" element={<PaymentProcessingPage />} />
          <Route path="/paiement/succes" element={<PaymentResultSuccess />} />

          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/conditions-generales" element={<ConditionsGenerales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/politique-de-cookies" element={<PolitiqueCookies />} />
        </Routes>
      </Router>
    </SitesProvider>
  );
}

export default App;